// @flow

import loadByHashid, {
  type LoadByHashidInjectedProps,
} from 'app/general/loadByHashid';
import loadVersions, {
  type LoadVersionsInjectedProps,
} from 'app/general/loadVersions';
import {
  fetchProceduresByHashid,
  fetchProcedureVersion,
  fetchProcedureVersions,
} from 'app/procedures/actions';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';
import {denormalizeProcedureFactory} from 'app/procedures/selectors';

export type {LoadByHashidInjectedProps, LoadVersionsInjectedProps};

export const loadProcedureByHashid = loadByHashid(
  fetchProceduresByHashid,
  ['proceduresPage', ['byId']],
  DetailLoadingPage,
  denormalizeProcedureFactory
);

export const loadProcedureVersionsByObjectid = loadVersions({
  fetchVersionsAction: fetchProcedureVersions,
  storeMap: ['proceduresPage', ['detailPage', 'procedureVersions']],
  LoadingComponent: DetailLoadingPage,
});

export const loadProcedureVersionByVersionId = loadVersions({
  fetchVersionsAction: fetchProcedureVersion,
  storeMap: ['proceduresPage', ['detailPage', 'procedureVersions']],
  LoadingComponent: DetailLoadingPage,
  fetchParamBuilder: (props) => props.params.versionid,
  waitForObjectVersion: true,
});
